import { TaxNote } from '@/modules/hs/types/tax.types'

/**
 * Tra cứu note thuế theo taxRate âm.
 * Giá trị âm trong DB là mã ghi chú (vd: -25 = "xem ghi chú 25").
 * Trả về undefined nếu rate không âm hoặc không tìm thấy note.
 */
export function lookupTaxNote(
    taxRate: number | null | undefined,
    notes: TaxNote[],
): string | undefined {
    if (taxRate == null || taxRate >= 0) return undefined
    return notes.find((note) => note.value === String(taxRate))?.textVn
}

/**
 * Kiểm tra taxRate có phải là mã ghi chú (giá trị âm) không.
 */
export function isTaxNoteCode(taxRate: number | null | undefined): boolean {
    return taxRate != null && taxRate < 0
}

/**
 * Tra note cho Thuế NK ưu đãi (NKUD).
 * NKTT = NKUD * 1.5 nên cả 2 loại thuế NK dùng chung kết quả này.
 */
export function getNkudNote(
    nkudRate: number | null,
    notes: TaxNote[],
): string | undefined {
    return lookupTaxNote(nkudRate, notes)
}

/**
 * Tra note cho Thuế tiêu thụ đặc biệt (TTDB).
 */
export function getTtdbNote(
    ttdbRate: number | null | undefined,
    notes: TaxNote[],
): string | undefined {
    return lookupTaxNote(ttdbRate, notes)
}

/**
 * Tra note cho Thuế GTGT (VAT).
 */
export function getVatNote(
    vatRate: number | null | undefined,
    notes: TaxNote[],
): string | undefined {
    return lookupTaxNote(vatRate, notes)
}
